import { useState } from "react";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import { useApi, useMe, errMsg } from "@/lib/api";

export const ConfirmEmail = () => {
  const api = useApi();
  const { me } = useMe();
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  if (!me || me.email_verified !== false) return null;
  const resend = async () => {
    setBusy(true);
    try { await api.post("/auth/phone/resend-verification"); setSent(true); toast.success(`Link sent to ${me.email}`); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-amber-300/60 bg-amber-50 p-4 sm:flex-row sm:items-center sm:justify-between" data-testid="confirm-email-banner">
      <p className="flex items-start gap-2 text-sm text-amber-900">
        <MailCheck className="mt-0.5 h-4 w-4 shrink-0" />
        <span>Confirm your email <b>{me.email}</b>. Tap the link we emailed you. Check Spam if you can't find it.</span>
      </p>
      <button onClick={resend} disabled={busy || sent} data-testid="confirm-email-resend"
        className="shrink-0 rounded-full bg-hc-green px-4 py-2 text-xs font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-50">
        {sent ? "Link sent" : busy ? "Sending…" : "Resend link"}
      </button>
    </div>
  );
};
